import { WSPanel } from "@wingspanhq/fe-component-library";
import { DefinitionDataSourceType } from "@wingspanhq/payments/dist/interfaces";
import {
  ISharedFileRequestSettingsCreateRequest,
  ISharedFileRequestSettingsResponse
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import * as Yup from "yup";

import { mapMimeTypesToRequestFormat } from "../../../../modules/BackgroundChecks/createRequirementDefinition/mapMimeTypesToRequestFormat";
import { CreateSharedFilePartialForm } from "../../../../modules/SharedFile/createRequirementDefinition/CreateSharedFilePartialForm";
import {
  mapMimeTypesToFormValues,
  MIME_TYPES_VALUES
} from "../../../../modules/SharedFile/createRequirementDefinition/utils";
import { RequirementDefinitionSharedFileFormValues } from "../../../../types";
import { RequirementDefinitionTemplateForm } from "../../types";

export const STANDARD_SHARED_FILE_FORM: RequirementDefinitionTemplateForm<
  ISharedFileRequestSettingsResponse,
  RequirementDefinitionSharedFileFormValues,
  ISharedFileRequestSettingsCreateRequest
> = {
  getDefaultSettingsValues: template => ({
    instructions: "",
    mimeTypes: {}
  }),
  getEditSettingsValues(template, requirementDefinition, settings) {
    return {
      instructions: settings.instructions ?? "",
      mimeTypes: mapMimeTypesToFormValues(settings.mimeTypes)
    };
  },
  mapDataSourceResponseToRequirementCreateRequest(response, template) {
    return {
      dataSourceId: response.sharedFileRequestSettingsId,
      dataSourceType: DefinitionDataSourceType.SharedFileRequestSettings
    };
  },
  mapFormDataToDataSourceCreateRequest(formValues, template) {
    return {
      contextType: formValues.contextType,
      instructions: formValues.instructions,
      mimeTypes: mapMimeTypesToRequestFormat(formValues.mimeTypes),
      title: formValues.name
    };
  },
  partialForm: (
    <WSPanel>
      <CreateSharedFilePartialForm />
    </WSPanel>
  ),
  successCreationMessage: "Requirement created successfully",
  validationSchema: Yup.object().shape({
    contextType: Yup.string() as any, //TODO: fix
    instructions: Yup.string(),
    mimeTypes: Yup.object()
      .test("isNotEmpty", "At least one MIME type is required", value => {
        return (
          value &&
          Object.keys(value).length > 0 &&
          Object.keys(value).every(
            key => MIME_TYPES_VALUES[key as keyof typeof MIME_TYPES_VALUES]
          ) &&
          Object.values(value).some(Boolean)
        );
      })
      .required("Required") as Yup.AnyObjectSchema
  })
};
